import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allData: [],
  selectedOptions: {
    tourType: "",
    date: "",
    time: "",
  },
  availableSlots: {
    date: [],
    time: {
      morning: [],
      afternoon: [],
    },
  },
  loading: false,
};

const scheduleTourSlices = createSlice({
  name: "scheduleTour",
  initialState,
  reducers: {
    resetScheduleTourState: (state) => {
      state.allData = [];

      state.selectedOptions = {
        tourType: "",
        date: "",
        time: "",
      };

      state.availableSlots = {
        date: [],
        time: {
          morning: [],
          afternoon: [],
        },
      };

      state.loading = false;
    },
    setAllData: (state, action) => {
      state.allData = action?.payload || [];
    },
    setSelectedOptions: (state, action) => {
      state.selectedOptions = action?.payload || initialState.selectedOptions;
    },
    setSelectedTourType: (state, action) => {
      state.selectedOptions.tourType = action?.payload || "";
    },
    setSelectedTourDate: (state, action) => {
      state.selectedOptions.date = action?.payload || "";
    },
    setSelectedTourTime: (state, action) => {
      state.selectedOptions.time = action?.payload || "";
    },
    setAvailableSlots: (state, action) => {
      state.availableSlots = action?.payload || initialState.availableSlots;
    },
    setAvailableDateSlots: (state, action) => {
      state.availableSlots.date = action?.payload || [];
    },
    setAvailableTimeSlots: (state, action) => {
      state.availableSlots.time = action?.payload || initialState.availableSlots.time;
    },
    setSlotsLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const selectSlotsLoading = (state) => state.scheduleTour.loading;
export const selectAllData = (state) => state.scheduleTour.allData;
export const selectSelectedOptions = (state) => state.scheduleTour.selectedOptions;
export const selectSelectedTourType = (state) => state.scheduleTour.selectedOptions.tourType;
export const selectSelectedTourDate = (state) => state.scheduleTour.selectedOptions.date;
export const selectSelectedTourTime = (state) => state.scheduleTour.selectedOptions.time;
export const selectAvailableSlots = (state) => state.scheduleTour.availableSlots;
export const selectAvailableDateSlots = (state) => state.scheduleTour.availableSlots.date;
export const selectAvailableTimeSlots = (state) => state.scheduleTour.availableSlots.time;
export const selectScheduleTourState = (state) => state.scheduleTour;

export const {
  setSlotsLoading,
  setAllData,
  setSelectedOptions,
  setSelectedTourType,
  setSelectedTourDate,
  setSelectedTourTime,
  setAvailableSlots,
  setAvailableDateSlots,
  setAvailableTimeSlots,
  resetScheduleTourState,
} = scheduleTourSlices.actions;

export default scheduleTourSlices.reducer;
